// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pq_a bih_sn bih_sv bih_sw bih_kx bih_ky bih_ke undefined bih_vt"};